import api from "../axios";

export type IdentityVerificationStatus =
  | "pending"
  | "in-progress"
  | "completed"
  | "failed";

export interface IdentityVerificationSummary {
  id: number;
  status: IdentityVerificationStatus;
}

/** Returns the current user's latest identity verification record, or null. */
export function getMyIdentityVerification() {
  return api.get<IdentityVerificationSummary | null>(
    "/identity-verifications/me",
  );
}

export function createIdentityLinkToken() {
  return api.post<{ link_token: string }>(
    "/identity-verifications/link-token",
  );
}

export function postIdentityVerificationCallback(linkSessionId: string) {
  return api.post<{ status: IdentityVerificationStatus }>(
    "/identity-verifications/callback",
    { linkSessionId },
  );
}
